import type { CourseValueType, ICourseOption } from '../CourseKitTypes'

interface IUseDropDownHotKeysProps<V extends CourseValueType> {
  options: ICourseOption<V>[]
  active: ICourseOption<V>
  setIsOpen: (isOpen: boolean) => void
  isOpen: boolean
  focusedOptionIndex: number
  focusedOptionId?: string | number
  setFocusedOptionId: (id?: string | number) => void
  target?: HTMLElement | null
  selectOption?: (item: ICourseOption<V>) => void
}

export const useDropDownHotKeys = <V extends CourseValueType>(
  props: IUseDropDownHotKeysProps<V>,
) => {
  const goToNextItem = () => {
    if (props.focusedOptionIndex < props.options.length - 1) {
      props.setFocusedOptionId(props.options[props.focusedOptionIndex + 1].id)
    }
  }

  const goToPrevItem = () => {
    if (!props.focusedOptionId) {
      props.setFocusedOptionId()
    }
    if (props.focusedOptionIndex > 0) {
      props.setFocusedOptionId(props.options[props.focusedOptionIndex - 1].id)
    }
  }

  const close = () => {
    props.setIsOpen(false)
    props.setFocusedOptionId()
  }

  return (e: React.KeyboardEvent) => {
    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault()
        if (props.isOpen) {
          goToPrevItem()
        } else {
          props.setIsOpen(true)
          props.setFocusedOptionId(props.options[props.options.length - 1].id)
        }
        break
      case 'ArrowDown':
        e.preventDefault()
        if (props.isOpen) {
          goToNextItem()
        } else {
          props.setIsOpen(true)
          props.setFocusedOptionId(props.options[0].id)
        }
        break
      case 'Enter':
      case ' ':
        if (!props.isOpen) {
          props.setIsOpen(true)
          props.setFocusedOptionId(props.active.id)
        } else {
          e.preventDefault()
          props.selectOption?.(props.options[props.focusedOptionIndex])
          close()
        }
        break
      case 'Escape':
        if (props.isOpen) {
          e.preventDefault()
          close()
        }
        break
      case 'Tab':
        if (props.isOpen) {
          close()
        }
        break
      default:
        break
    }
  }
}
